import React, { useState, useCallback, useContext, useEffect, useRef } from "react";
import { View, Image, Dimensions, Button, Text, TouchableOpacity, StyleSheet, TextInput, ActivityIndicator, Platform } from 'react-native'
import * as DocumentPicker from 'expo-document-picker';
import { Color } from './../utils/color';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Constants } from './../utils/constants';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { CheckBox, Autocomplete, AutocompleteItem } from '@ui-kitten/components';



const TranscriptionUploader = ({ isTranscription, userToken, supportedLanguages=[], getData, refreshHistoryTable }) => {
  
    const [success, setSuccess] = useState('')
    const [file, setFile] = useState()
    const [fileName, setFileName] = useState('')
    const [fileSize, setFileSize] = useState('')
    const [fileDuration, setFileDuration] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [processMessage, setProcessMessage] = useState(null)

    const [loading, setLoading] = useState(false)
    const [gettingFile, setGettingFile] = useState(false)

    const [diarize, setDiarize] = useState(false)
    const [translate, setTranslate] = useState(false)
    const [sentimentAnalysis, setSentimentAnalysis] = useState(false)
    const [topicIdentification, setTopicIdentitification] = useState(false)

    const taskArr = [{name: 'Transcribe + Diarize', task: 'diarize'}, {name: 'Translate', task: 'translate'}]

    const [languages, setLanguages] = useState([])
    const [languageArr, setLanguageArr] = useState([])  // hold a copy of supported languages for filtering
    const [languageSearchText, setLanguageSearchText] = useState('English')
    const [selectedLanguage, setSelectedLanguage] = useState({ "code": "en", "name": "English" })

    const [selectedTask, setSelectedStask] = useState({name: 'Transcribe + Diarize', task: 'diarize'})

    const fileInputRef = useRef(null);

    // Reference map of languages and their ISO 639-1 codes - For all languages
    const languageMap = {
      "Afrikaans": "af",
      "Albanian": "sq",
      "Amharic": "am",
      "Arabic": "ar",
      "Armenian": "hy",
      "Azerbaijani": "az",
      "Basque": "eu",
      "Belarusian": "be",
      "Bengali": "bn",
      "Bosnian": "bs",
      "Bulgarian": "bg",
      "Catalan": "ca",
      "Cebuano": "ceb",
      "Chhattisgarhi": "hne",
      "Chinese": "zh",
      "Croatian": "hr",
      "Czech": "cs",
      "Danish": "da",
      "Dari": "prs",
      "Dutch": "nl",
      "English": "en",
      "Esperanto": "eo",
      "Estonian": "et",
      "Ewe": "ee",
      "Faroese": "fo",
      "Fijian": "fj",
      "Finnish": "fi",
      "French": "fr",
      "Friulian": "fur",
      "Galician": "gl",
      "Georgian": "ka",
      "German": "de",
      "Greek": "el",
      "Gujarati": "gu",
      "Haitian Creole": "ht",
      "Hausa": "ha",
      "Hebrew": "he",
      "Hindi": "hi",
      "Hungarian": "hu",
      "Icelandic": "is",
      "Igbo": "ig",
      "Indonesian": "id",
      "Irish": "ga",
      "Italian": "it",
      "Japanese": "ja",
      "Javanese": "jv",
      "Kannada": "kn",
      "Kazakh": "kk",
      "Khmer": "km",
      "Kikuyu": "ki",
      "Kinyarwanda": "rw",
      "Korean": "ko",
      "Kurdish": "ku",
      "Kyrgyz": "ky",
      "Lao": "lo",
      "Latin": "la",
      "Latvian": "lv",
      "Lithuanian": "lt",
      "Luxembourgish": "lb",
      "Macedonian": "mk",
      "Malagasy": "mg",
      "Malay": "ms",
      "Malayalam": "ml",
      "Maltese": "mt",
      "Maori": "mi",
      "Marathi": "mr",
      "Mongolian": "mn",
      "Nepali": "ne",
      "Norwegian": "no",
      "Occitan": "oc",
      "Odia": "or",
      "Pashto": "ps",
      "Persian": "fa",
      "Polish": "pl",
      "Portuguese": "pt",
      "Punjabi": "pa",
      "Romanian": "ro",
      "Russian": "ru",
      "Serbian": "sr",
      "Sesotho": "st",
      "Sinhala": "si",
      "Slovak": "sk",
      "Slovenian": "sl",
      "Somali": "so",
      "Spanish": "es",
      "Sundanese": "su",
      "Swahili": "sw",
      "Swedish": "sv",
      "Tamil": "ta",
      "Telugu": "te",
      "Thai": "th",
      "Turkish": "tr",
      "Ukrainian": "uk",
      "Urdu": "ur",
      "Uzbek": "uz",
      "Vietnamese": "vi",
      "Welsh": "cy",
      "Xhosa": "xh",
      "Yiddish": "yi",
      "Yoruba": "yo",
      "Zulu": "zu"
    };
    
    // To match the supported languages to their ISO codes
    useEffect(()=>{
      // If supportedLanguages becomes object of not reason, prevent from filtering it
      if(supportedLanguages.length < 1 || !Array.isArray(supportedLanguages)) return 

      const supportedLanguagesWithCodes = supportedLanguages?.filter(lang => languageMap[lang]) // Filter out any unknown language names
      .map(lang => ({
        code: languageMap[lang],
        name: lang,
      }));

      setLanguages(supportedLanguagesWithCodes)
      setLanguageArr(supportedLanguagesWithCodes)
    },[supportedLanguages])

    const getFile = async()=>{
      setSuccess('')
      setErrorMessage('')
      let result = await DocumentPicker.getDocumentAsync({
        type: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','text/csv']
        })

      if(result.file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || result.file.type == 'text/csv'){
        setFile(()=>result)
      } else {
        setErrorMessage('Error file type not supported.')
        return
      }
    }

    // For picking files on ios and android
    const getAudioVideoFiles = async()=>{
      // setGettingFile(true) expo document picker does not return promise on 'cancel'
      setSuccess('')
      setErrorMessage('')
      let result = await DocumentPicker.getDocumentAsync({
        type: [
          'audio/mp3', 
          // 'audio/m4a',
          // 'video/mp4'
      ]
        })

      setFile(()=>result)
      // setGettingFile(false)
    }

    // Function to simulate file input click
    const triggerFileInputClick = () => {
        fileInputRef.current.click();
    };

    // Handle audio file upload on web with browser APIs
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
        getAudioDuration(file); // Calculate the duration
        }
    };

    // Calculate audio duration
    const getAudioDuration = (file) => {
        const audio = new Audio();
        audio.src = URL.createObjectURL(file);

        // Wait for the audio to load and then get the duration
        audio.onloadedmetadata = () => {
        setFile(file)
        setFileDuration(audio.duration)
        };
    };

    // Format the duration
    const formatDuration = (durationInSeconds) => {
        const hours = Math.floor(durationInSeconds / 3600);
        const minutes = Math.floor((durationInSeconds % 3600) / 60);
        const seconds = Math.round(durationInSeconds % 60);

        // If less than 1 minute, show seconds
        if (durationInSeconds < 60) {
        return `${seconds}s`;
        }

        // If less than 1 hour, show minutes and seconds
        if (durationInSeconds < 3600) {
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}m`;
        }

        // If more than 1 hour, show hours, minutes, and seconds
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}h`;
    };

    const removeFile = async()=>{
      setSuccess('')
      setFile()
      setFileName('')
      setFileSize('')
      setErrorMessage('')
      setSentimentAnalysis(false)
      setTopicIdentitification(false)
      setProcessMessage(null)
    }

    useEffect(()=>{
     if(file){
      setFileName(file.name)

      const MB = 1024 * 1024
      const fileSizeinMB = (file.size / MB).toFixed(2)

      setFileSize(fileSizeinMB)
     } return
    },[file])

    // Only upload file and get back a session id
    const uploadFile = async () => {

        setLoading(true)

        let result = {file : file }
        
        const data = new FormData();
        data.append('audio_input', result.file);
        data.append('audio_lenght', fileDuration);

        if(diarize){
          data.append("tasks", "diarize");
        }
        if(translate){
          data.append("tasks", "translate");
        }
        data.append("spoken_language", selectedLanguage.code); // language in the audio
        data.append("target_language", "en"); // target language
        data.append("sentiment_analysis", sentimentAnalysis ? true : false);
        data.append("topic_classification", topicIdentification ? true : false);

        setProcessMessage('Uploading file...')

        fetch(`https://cxml.cxsphere.com/transcribe`, {
          method: "POST",
          headers: {
            'Authorization': `Bearer ${userToken}`
          },
          body: data
        })
        .then(async(res) => res.json())
        .then((res)=>{
          if(!res.session_id){console.log('error in uploading'); return}

          setProcessMessage('✅ Upload successful. You can wait here or check back in later to view results.')
          getData(null) // to reset the result
          setFile()
          setLoading(false)

          refreshHistoryTable()

        // This endpoint will not return results but returns session_id. Loop/fetch/poll /transcribe/results endpoint with the session_id
        const interval = setInterval(async() => {
          const result = await  getSessionResult(res.session_id) // poll endpoint
  
          // Finally when we have the results
          if(result){
            clearInterval(interval)
            getData({result, fileName, fileSize})
            setSuccess('')
            setFile()
            setFileName('')
            setLoading(false)
            setProcessMessage(null)
          }
        }, 20000);
      
        return () => clearInterval(interval);
         
        })
        .catch(()=>{
          console.log('fetch request not made')
          setLoading(false)
          setProcessMessage('Error uploading file')
        })
    }

    // This function is polled until we get results
    const getSessionResult = async (session_id) => {
      
     const result = fetch(`https://cxml.cxsphere.com/transcribe/results/${session_id}`, {
          method: "GET",
          headers: {
            'Authorization': `Bearer ${userToken}`
          }
        })
        .then(async(res) => res.json())
        .then((result)=>{
          if(result.id){
            return result
          } else null
        })
        .catch(()=>{
          return null
        })

      return result
    }

    // Render Autocomplete options
    const renderOptionLanguage = (item, index) => {
        return (
        <AutocompleteItem
            key={index}
            title={item.name}
        />
        );
    };

    const renderTaskOptions = (item, index) => {
        return (
        <AutocompleteItem
          key={index}
          title={item.name}
        />
        );
    };
   
    // On selecting from dropdown
    const onSelectLanguage = (index) => {
        const language = languages[index]

        // Uncheck translate if english is selected
        if(language.code == 'en'){
          setTranslate(false)
        }
       
        setSelectedLanguage(language)
        setLanguageSearchText(language.name)
    };

    const onSelectTask = (index) => {
        const task = taskArr[index]
        setSelectedStask(task)
    };

    // On typing into the Autocomplete box
    const filter = (item, query) => item.toLowerCase().includes(query.toLowerCase());

    const onChangeTextLanguage = (query) => {
        setLanguages(languageArr.filter(item => filter(item.name, query)))
        setLanguageSearchText(query) // sets the search term
    };

    // When clicked outside the Autocomplete box
    const handleBlur = () => {
      const match = languages.find(
        (option) => option.name.toLowerCase() === languageSearchText.toLowerCase()
      );
      if (match) {
        // If the typed text matches with any of the array elements
        // && only when clicked outside the box or hit enter
        setSelectedLanguage(match);
        setLanguageSearchText(match.name)
      } else {
        // If no match set the search text back to existing selectedLanguage
        setLanguageSearchText(selectedLanguage.name)
      }
    };

 return (
      <View style={{ 
      width: Dimensions.get('window').width * 0.9,
      maxWidth: 700,
      marginLeft:15,
      marginTop: 15, 
      marginBottom: 15, 
      height: 400, 
      borderStyle: 'dashed',
      borderColor: Color.DarkGreen,
      backgroundColor:'#fff', 
      borderRadius:10,
      borderRightWidth:1, 
      borderLeftWidth:1, 
      borderBottomWidth:1, 
      borderTopWidth:1,
      justifyContent: (file ? 'flex-start' : 'center'),
      alignItems:(file ? 'center' : 'center'),      
    }}>

     <View style={{flexDirection: 'row'}}>
        {loading && 
        <View style={{flexDirection: 'row', marginTop: 10, marginRight: 10}}>
          <ActivityIndicator/>
        </View>}

        {processMessage && <Text style={{marginBottom: 10, marginTop: 10}}>{processMessage}</Text>}
     </View>

          <View>  
            {!file ? 
            (<View style={{width: 150, alignItems: 'center', justifyContent: 'center'}}>
            {Platform.OS !== 'ios' || Platform.OS !== 'android' ? 
          
              <>
                <input type="file" accept=".mp3, .m4a" ref={fileInputRef} onChange={handleFileChange} style={{display: 'none'}} />
                <Button onPress={() => [isTranscription ? triggerFileInputClick() :  null]}
                    disabled={gettingFile}
                    backgroundColor={Color.DarkGreen}
                    color={Color.DarkGreen}
                    title={gettingFile ? "Loading..." : "Add a new File"}>
                  </Button>
              </>
              
            :

              <Button onPress={() => [isTranscription ? getAudioVideoFiles() :  getFile()]}
                disabled={gettingFile}
                backgroundColor={Color.DarkGreen}
                color={Color.DarkGreen}
                title={gettingFile ? "Loading..." : "Add a new File"}>
              </Button>
            }
              <Text style={{ fontSize: 10, color: 'black'}}>file format {isTranscription ? ".mp3, .m4a" : ".csv or .xlsx"}</Text>
            </View> ) :
            (<View style={{justifyContent: 'space-between'}}>
              <TouchableOpacity style={styles.card} activeOpacity={.6}>
                <Text style={{maxWidth: '40%', fontWeight: '500', marginRight: 30}} lineBreakMode='tail' numberOfLines={1}>{fileName}</Text>
                <Text style={{fontWeight: '500', width: 100, textAlign: 'center'}} numberOfLines={1}>{formatDuration(fileDuration)}</Text>
                <Text style={{fontWeight: '500', width: 100}} numberOfLines={1}>{fileSize} MB</Text>
                <View style={{flexDirection: 'row'}}>
                  <TouchableOpacity 
                  disabled={loading}
                  onPress={()=>removeFile()}>
                    <MaterialCommunityIcons name="delete" size={20} color="black" style={{marginLeft: 20}} />
                  </TouchableOpacity>
                </View>
              </TouchableOpacity>
            </View>)}
          </View>


            <View style={{alignSelf: 'center', marginTop: 20}}>
              {isTranscription && 
                <View style={{flexDirection: 'column', alignItems: 'flex-start', marginBottom: 20}}>
                 
                {/* Dropdown */}
                {/* <Autocomplete
                  style={{marginBottom: 10}}
                  placeholder='Choose Task'
                  value={selectedTask.name}
                  onSelect={onSelectTask}
                  size="small"
                  >
                  {taskArr.map(renderTaskOptions)}
                </Autocomplete> */}


                <Text style={{marginBottom: 5}}>Primary language in the audio file: </Text>
                {/* Dropdown */}
                <Autocomplete
                  style={{marginBottom: 10}}
                  placeholder='Primary Language'
                  value={languageSearchText}
                  onSelect={onSelectLanguage}
                  size="small"
                  onChangeText={onChangeTextLanguage}
                  onBlur={handleBlur} // to handle rouge clicks outside the box
                  >
                  {languages.map(renderOptionLanguage)}
                </Autocomplete>

                <Text style={{marginBottom: 5}}>Tasks: </Text>
                <CheckBox
                  disabled={selectedLanguage.code == 'en'}
                  style={{margin: 5}}
                  checked={translate}
                  onChange={check => setTranslate(check)}
                  >Translate
                </CheckBox>

                 <CheckBox
                  style={{margin: 5}}
                  checked={diarize}
                  onChange={check => setDiarize(check)} 
                  >Diarize
                </CheckBox>

                <CheckBox
                  style={{margin: 5}}
                  checked={sentimentAnalysis}
                  onChange={check => setSentimentAnalysis(check)} 
                  >Sentiment Analysis
                </CheckBox>

                <CheckBox
                  style={{margin: 5}}
                  checked={topicIdentification}
                  onChange={check => setTopicIdentitification(check)}
                  >Topic Identification
                </CheckBox>
              </View>
              }

              <Button
                // disabled={isTranscription && selectedOptions.length == 0 && !validLang || loading} 
                disabled={!file || loading}
                onPress={() => uploadFile()}
                backgroundColor={Color.DarkGreen}
                color={Color.DarkGreen}
                title="Upload File">
              </Button>
            </View>
            

            {!file && success.length > 0 &&
            <View style={{backgroundColor: '#e3e3e3', position: 'absolute', bottom: 200, padding: 10, borderRadius: 8}}>
            <Text>{success}</Text>
            </View>}

            {errorMessage.length > 0 && 
            <View style={{backgroundColor: '#e3e3e3', bottom: 200, padding: 10, borderRadius: 8, borderWidth: 1, borderColor: 'red', alignSelf: 'center', opacity: .8}}>
            <Text>{errorMessage}</Text>
            </View>}
        </View>
    );
    
  };

  export default TranscriptionUploader;

  const styles = StyleSheet.create({
    card:{
      flexDirection: 'row', 
      padding: 10, 
      justifyContent: 'space-between', 
      backgroundColor: 'white', 
      borderRadius: 4, 
      borderWidth: 1, 
      borderColor: '#e3e3e3',
      margin: 10, 
      maxWidth: 400, 
      // maxWidth: '90%',
      minHeight: 50,
      alignItems: 'center'
    }
  })
